if (avastGlobals.detect.browser.isFirefox) {
	document.querySelector('body').classList.add('detect-firefox');
} else if (avastGlobals.detect.browser.isChrome) {
	document.querySelector('body').classList.add('detect-chrome');
} else if (avastGlobals.detect.browser.isEdge) {
	document.querySelector('body').classList.add('detect-edge');
} else {
	document.querySelector('body').classList.add('detect-other');
}
